import { RouteConfig } from "vue-router";

export const REmployerVisaCasesBrowse: RouteConfig = {
  path: "",
  name: "EmployerVisaCasesBrowse",
  component: () =>
    import(
      /* webpackChunkName: "employer-visa-cases-browse" */
      "./VEmployerVisaCasesBrowse.vue"
    ),
  meta: {
    title: "Visa cases",
    version: 2,
  },
};
